import { put, takeEvery } from 'redux-saga/effects'
import { LOAD_AUTHENTICATIONTOKEN_ERROR, LOAD_AUTHENTICATIONTOKEN_SUCCESS, LOAD_AUTHENTICATIONTOKEN_LOADING } from "../actions/actionAuthentication";
import apiAuthentication from '../api/apiAuthentication';

async function fetchAsync(func) {
  const response = await func();
  if (response.ok) {
    return await response.json();
  }
  throw new Error("Unexpected error!!!");
}


function* fetchAuthenticationToken() {
  try {
    const token = yield fetchAsync(apiAuthentication);
    yield put({ type: LOAD_AUTHENTICATIONTOKEN_SUCCESS, token: token });
  } catch (e) {
    yield put({ type: LOAD_AUTHENTICATIONTOKEN_ERROR, error: e.message });
  }
}
export const sagaAuthenticationToken = [  // Allows concurrent fetches
  takeEvery(LOAD_AUTHENTICATIONTOKEN_LOADING, fetchAuthenticationToken)
  // Does not allow concurrent fetches
  // yield takeLatest(LOAD_USERS_LOADING, fetchUser);
];


//export default authenticationTokenSaga;
